import React from 'react';

import Box from '@mui/material/Box';

type ActionPanelTabContentProps = {
	active: boolean;
	children: React.ReactNode;
	innerBoxSx?: React.ComponentProps<typeof Box>['sx'];
};

export default function ActionPanelTabContent({ active, children, innerBoxSx }: ActionPanelTabContentProps) {
	return (
		<Box sx={{ position: 'relative', flex: 1, minHeight: 0, display: active ? 'flex' : 'none' }}>
			<Box sx={{ position: 'absolute', inset: 0, p: 2, ...innerBoxSx }}>{children}</Box>
		</Box>
	);
}
